import React from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const CanonicalTag = () => {
  const location = useLocation();
  const origin = typeof window !== "undefined" ? window.location.origin : "https://whistle.in";
  let path = location.pathname;
  if (path.endsWith("/") && path.length > 1) {
    path = path.slice(0, -1);
  }
  const canonicalUrl = `${origin}${path}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default CanonicalTag;
